

















import { Component, Prop, Vue } from 'vue-property-decorator'
import { FileSizeFormatter } from '../../modules/class/Downloads'
import { PdfLink } from '../../modules/class/PdfDownload/Conditions'
import RemoveTag from '@/components/Parts/RemoveTag.vue'

@Component({
  components: { RemoveTag }
})
export default class LinkItem extends Vue {
  @Prop() private item!: PdfLink

  /**
   * ファイルサイズをフォーマット
   */
  get fileSize(): string {
    return FileSizeFormatter.fileSizeFormat(this.item.size)
  }
}
